export function academicCalendarListByFilterTable(filter) {
  let filterClone = { ...filter };
  if (filter.schoolTerms) {
    const schoolTermId = filter.schoolTerms.id;
    const { schoolTerms, ...newFilter } = filter;
    filterClone = { ...newFilter, schoolTermId };
  }

  return `{
    academicCalendarListByFilter (filter: ${JSON.stringify(filterClone).replace(
      /"([^(")"]+)":/g,
      '$1:'
    )}) {
        id
        name
        schoolTerm{
          id
          name
          year
        }
    }    
}`;
}

export function academicCalendarListByFilter(filter) {
  return `{
    academicCalendarListByFilter (filter: ${JSON.stringify(filter).replace(
      /"([^(")"]+)":/g,
      '$1:'
    )}) {
        id,
        name,
        schoolTerm{id, name, year},
        sunday,
        monday,
        tuesday,
        wednesday,
        thursday,
        friday,
        saturday,
        active,
        stepQuantity,
        schoolDaysQuantity,    
        calendarMarkers
            {
                id,
                name,
                color,
                schoolDay,
                uuid,
            },
        calendarCycles {
            id,
            name,
            sequence,
            beginInMilli,
            endInMilli , 
            uuid,
            color,
        }
        calendarDays {
            id,
            schoolDay,
            workDay,
            dateInMilli,
            markers{
                id
                title
                description
                uuid
                marker {
                    id,
                    name,
                    color,
                    schoolDay,
                    uuid
                }
                cycle {
                    id
                    name
                    sequence
                    beginInMilli
                    endInMilli
                    uuid,
                    color
                }
            }  
        }
    }    
}`;
}

export function saveAcademicCalendarMutation(
  values,
  calendarDays,
  calendarMarkers
) {
  const { name, weekdays, calendarCycles } = values;

  const calendarCyclesFormatted = calendarCycles.map((cycle) => {
    if (cycle.value || cycle.label) {
      const { value, label, ...markerRest } = cycle;
      return markerRest;
    }
    return cycle;
  });

  const calendarMarkersFormatted = calendarMarkers.map((item) => {
    if (item.value || item.label) {
      const { value, label, ...markerRest } = item;
      return markerRest;
    }
    return item;
  });

  const stepQuantity =
    parseInt(values.stepQuantity, 10) === calendarCyclesFormatted.length
      ? parseInt(values.stepQuantity, 10)
      : calendarCyclesFormatted.length;

  const mutationQuery = `mutation{
    academicCalendarSave(
        academicCalendar: {
            id: ${values.id || 0},
            name: "${name}",
            sunday: ${weekdays[0]},
            monday: ${weekdays[1]},
            tuesday: ${weekdays[2]},
            wednesday: ${weekdays[3]},
            thursday: ${weekdays[4]},
            friday: ${weekdays[5]},
            saturday: ${weekdays[6]},
            stepQuantity: ${stepQuantity},
            calendarMarkers: ${JSON.stringify(calendarMarkersFormatted).replace(
              /"([^(")"]+)":/g,
              '$1:'
            )},
            calendarCycles: ${JSON.stringify(calendarCyclesFormatted).replace(
              /"([^(")"]+)":/g,
              '$1:'
            )}
            schoolTerm: {
                id: ${values.schoolTerm.id},
                finalDate: 0, 
                filterByStatus: false,
                updaterId: 0,
                year: 0,
                initialDate: 0
            }            
            active: ${values.active},
            schoolDaysQuantity: ${values.schoolDaysQuantity || 0},
            calendarDays: ${JSON.stringify(calendarDays).replace(
              /"([^(")"]+)":/g,
              '$1:'
            )}
        }
    )    
    {id}
}`;
  return mutationQuery;
}

export function academicCalendarRemove(id) {
  return `mutation{academicCalendarRemove(academicCalendarId: ${id})}`;
}
export function academicCalendarListByFilterForTimetable(filter) {
  let filterClone = { ...filter };
  if (filter.schoolTerms) {
    const schoolTermId = filter.schoolTerms.id;
    const { schoolTerms, ...newFilter } = filter;
    filterClone = { ...newFilter, schoolTermId };
  }

  return `{
    academicCalendarListByFilter (filter: ${JSON.stringify(filterClone).replace(
      /"([^(")"]+)":/g,
      '$1:'
    )}) {
        id
        name
        sunday,
        monday,
        tuesday,
        wednesday,
        thursday,
        friday,
        saturday,
        schoolTerm{
          id
          name
          year
        },
        calendarCycles {
          id
        }
    }    
}`;
}

export function workingDays() {
  return `{ findSchool{ workingDays }}`;
}

export function listDaysByAcademicCalendar(
  academicCalendarId,
  schoolTermId,
  weekdayStr
) {
  const arrayChar = weekdayStr.split(';');
  const weekdays = arrayChar.map((char) => Boolean(Number(char)));
  const query = `{
    academicCalendarListDaysByAcademicCalendar(
                filter: { 
                  id: ${academicCalendarId}, 
                  schoolTerm: {
                    id: ${schoolTermId}, 
                    finalDate: 0, 
                    filterByStatus:false, 
                    updaterId:0, 
                    year:0, 
                    initialDate:0
                  }
                  sunday: ${weekdays[0]}
                  monday: ${weekdays[1]}
                  tuesday: ${weekdays[2]}
                  wednesday: ${weekdays[3]}
                  thursday: ${weekdays[4]}
                  friday: ${weekdays[5]}
                  saturday: ${weekdays[6]}
                })
                {
                id,
                schoolDay,
                workDay,
                dateInMilli,
                markers{
                    id,
                    marker {
                        id,
                        name,
                        color,
                        schoolDay
                    }
                }                
    }
}`;
  return query;
}

export function findAcademicCalendarDayByAcademicCalendar(id) {
  return `{
  findAcademicCalendarDayByAcademicCalendar(academicCalendar: { id: ${id} }) {
    id
    dateInMilli
  }
}`;
}
